
import { defineComponent } from "vue";
import RawResult from "../emoji/RawResult.vue";
import Preview from "../emoji/Preview.vue";
import Checkbox from "../inputs/Checkbox.vue";
import Space from "../global/Space.vue";
import Card from "../global/Card.vue";

export default defineComponent({
  components: {
    RawResult, Preview, Checkbox, Card, Space,
  },
  props: {
    images: { type: Array, required: true },
  },
  data() {
    return {
      previewMode: false,
    };
  },
});
